import React, {Component} from "react"
import {Row, Col} from "react-bootstrap"
import moment from "moment"

import {hangPromise} from "@irati/utils/promise"
import tracking from "@irati-tracking/admin"
import Loading from "@irati/ui/src/Loading"
import {H2} from "@irati/ui/src/Typography"
import {Overview, ReportingTeamState, TeamReport, TeamDateInput, TeamReportDuration} from "@irati/types"
import authentication from "@irati/auth"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import Tabs from "@irati/ui/src/Tabs"

import adminReportingService from "@irati/adminReporting/services/adminReporting"

import OrganisationalSummary from "../../../components/OrganisationalSummary"
import TeamEngagement from "../../../components/Reporting/TeamEngagement"
import PlatformActivityBlock from "../../../components/Reporting/PlatformActivity/PlatformActivityBlock/index"
import PlatformActivityByTeam from "../../../components/Reporting/PlatformActivity/PlatformActivityByTeam/index"
import BenchmarkGraph from "../../../components/Reporting/BenchmarkGraph"
import {StyledHr} from "../styled/index"

const CURRENT_DATE: TeamDateInput = {
  month: parseInt(moment().format("M"), 10),
  year: parseInt(moment().format("YYYY"), 10)
}

interface Props extends InjectIntl {}

interface State {
  platformActivity: Overview,
  load: Promise<void>,
  page: number,
  teams: TeamReport[],
  regions: TeamReport[]
}

class Company extends Component<Props, State> {
  state = {
    platformActivity: {},
    load: hangPromise(),
    teams: [],
    regions: []
  }

  componentDidMount = () => {
    this.setState({
      load: Promise.all([this.getTeamReports(), this.getUsersOverview()])
    })
    tracking.analyticsOverall()
  }

  getTeamReports = async() => {
    const teams = await adminReportingService.getTeamReports(
      authentication.business().uuid,
      TeamReportDuration.Month,
      [ReportingTeamState.Generic],
      CURRENT_DATE)
    const regions = await adminReportingService.getTeamReports(
      authentication.business().uuid,
      TeamReportDuration.Month,
      [ReportingTeamState.BillingUnit],
      CURRENT_DATE, {fetchPolicy: "network-only"})
    this.setState({teams: teams.reports, regions: regions.reports})
  }

  getUsersOverview = () => {
    const businessId = authentication.business().uuid
    return adminReportingService
      .getOverview(businessId)
      .then(({activated, users, activatedUsers}) => {
        this.setState({
          platformActivity: {activated: (activated * 100).toFixed(), users, activatedUsers}
        })
      })
  }

  render() {
    const {platformActivity, teams, regions, load} = this.state
    const {formatMessage} = this.props

    return (
      <Row>
        <Tabs
          id="adminSection_reportingTab"
          addMarginTop
          mountOnEnter
          unmountOnExit
          tabs={[
            {
              title: formatMessage({id: "admin.reporting.tabs.engagementSummary"}),
              key: "engagementSummary",
              component: (
                <Col xs={12}>
                  <OrganisationalSummary />
                </Col>
              )
            },
            {
              title: formatMessage({id: "admin.reporting.tabs.activation"}),
              key: "activation",
              component: (
                  <>
                    <Col xs={12}>
                      <H2 marginBottom={4}>
                        <FormattedMessage id="admin.analytics.overall.title" />
                      </H2>
                      <Loading load={load}>
                        <StyledHr />
                        <PlatformActivityBlock platformActivity={platformActivity} />
                      </Loading>
                    </Col>
                    <Col xs={6}>
                      <Loading load={load}>
                        <StyledHr />
                        <PlatformActivityByTeam
                          isRegion
                          teams={regions} />
                      </Loading>
                    </Col>
                    <Col xs={6}>
                      <Loading load={load}>
                        <StyledHr />
                        <PlatformActivityByTeam teams={teams} />
                      </Loading>
                    </Col>
                    </>

              )
            },
            {
              title: formatMessage({id: "admin.reporting.tabs.benchmark"}),
              key: "benchmark",
              component: (
                <Col xs={12}>
                  <BenchmarkGraph />
                </Col>
              )
            },
            {
              title: formatMessage({id: "admin.reporting.tabs.team"}),
              key: "teamAnalysis",
              component: (
                <Col xs={12}>
                  <TeamEngagement />
                </Col>
              )
            }
          ]} />
      </Row>
    )
  }
}

export default injectIntl(Company)
